module.exports = __webpack_public_path__ + "img/fzu.1c3b8c3d.png";